export default __webpack_public_path__ + "static/media/Maple Leafs.0cd1b0f4.png";